/*
  A series of circles that indicate the position of a selection in a sequence.
*/

import { Component, PropTypes } from "react";
import classNames from "classnames";
import { times } from "lodash";

class SequenceIndicators extends Component {

  renderIndicatorCircle(idx) {
    const indicatorCircleClasses = classNames( "sequenceIndicators__circle",
      { "sequenceIndicators__circle--selected": idx === this.props.selectedIndex }
    );
    return <div key={idx} className={indicatorCircleClasses} />;
  }

  render() {
    return (
      <div className="sequenceIndicators">
        {times(this.props.count, (idx) => this.renderIndicatorCircle(idx))}
      </div>
    );
  }
}

SequenceIndicators.propTypes = {
  count: PropTypes.number.isRequired,
  selectedIndex: PropTypes.number.isRequired,
};

export default SequenceIndicators;
